import { makeAutoObservable } from 'mobx';

import { CategoryItemModel, PossibleDays } from '@popularKeyword/common-types';

class MonthlyKeywordStore {
  currentDate: string | null = null;

  totalRankingData: any | null = null;

  possibleDaysData: PossibleDays[] | [] = [];

  categoryData: CategoryItemModel[] | null = null;

  categoryTotalItemCount = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentDate = (date: string) => {
    this.currentDate = date;
  };

  setTotalRankingData = (data: any) => {
    this.totalRankingData = data;
    this.setTotalItemCountByCategory(data.categoryName, data.totalItemCount);
  };

  setCategoryData = (data: CategoryItemModel[]) => {
    if (!data) return;
    this.categoryData = data;
    data.forEach((item) => {
      this.setTotalItemCountByCategory(item.categoryName, item.totalItemCount);
    });
  };

  setPossibleDaysData = (data: PossibleDays[]) => {
    this.possibleDaysData = data;
  };

  setTotalItemCountByCategory = (categoryName: string, count: number) => {
    this.categoryTotalItemCount.set(categoryName, count);
  };

  getTotalItemCountByCategory = (categoryName: string) => {
    return this.categoryTotalItemCount.get(categoryName);
  };
}

export default new MonthlyKeywordStore();
